import { MicrositeTemplate } from '~/model';
import { useRegisterSection } from '~/hooks/useSections';
import GalleryBlockAlpha from '~/editor/templates/alpha/GalleryBlockAlpha';
import GalleryBlockDelta from '~/editor/templates/delta/GalleryBlockDelta';
import GalleryBlockEpsilon from '~/editor/templates/epsilon/GalleryBlockEpsilon';
import GalleryBlockEta from '~/editor/templates/eta/GalleryBlockEta';
import GalleryBlockZeta from '~/editor/templates/zeta/GalleryBlockZeta';
import { type ComponentConfig } from '@puckeditor/core';
import { DEMO_PHOTOS } from '~/demo';
import GalleryBlockBeta from '~/editor/templates/beta/GalleryBlockBeta';

export interface GalleryBlockProps {
	navigation?: boolean;
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_GALLERY: ComponentConfig<GalleryBlockProps> = {
	label: 'Photo Gallery',
	fields: {
		navigation: {
			type: 'radio',
			options: [
				{ label: 'On', value: true },
				{ label: 'Off', value: false },
			],
		},
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		navigation: true,
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <GalleryBlock {...props} />;
	},
};

export default function GalleryBlock({ navigation = true, template }: GalleryBlockProps) {
	const id = useRegisterSection('gallery', 'Photos', navigation);

	let content = <></>;

	if (template === MicrositeTemplate.ALPHA) {
		content = <GalleryBlockAlpha photos={DEMO_PHOTOS} />;
	}
	if (template === MicrositeTemplate.BETA) {
		return <GalleryBlockBeta id={id} photos={DEMO_PHOTOS} />;
	}
	if (template === MicrositeTemplate.DELTA) {
		content = <GalleryBlockDelta photos={DEMO_PHOTOS} />;
	}
	if (template === MicrositeTemplate.EPSILON) {
		content = <GalleryBlockEpsilon photos={DEMO_PHOTOS} />;
	}
	if (template === MicrositeTemplate.ETA) {
		content = <GalleryBlockEta photos={DEMO_PHOTOS} navigation={navigation} />;
	}
	if (template === MicrositeTemplate.ZETA) {
		content = <GalleryBlockZeta photos={DEMO_PHOTOS} />;
	}

	return <div id={id}>{content}</div>;
}
